import React, { createContext, ReactNode, useState } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { ChakraProvider } from '@chakra-ui/react';
import { chakraTheme } from './chakraTheme';
import {
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_SECONDARY_COLOR,
} from '../../containers/prescription/usePrescription/helpers.mock';
import { materialTheme } from './materialTheme';
import { BaseThemeColors } from './interfaces/baseThemeColors';

interface ThemeProviderProps {
  children: ReactNode;
}

interface ThemeContextProps {
  themeColor: BaseThemeColors;
  setThemeColor(themeColor: BaseThemeColors): void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  themeColor: { primary: DEFAULT_PRIMARY_COLOR, secondary: DEFAULT_SECONDARY_COLOR },
  setThemeColor: (themeColor: BaseThemeColors) => {},
});

function ThemeProvider(props: ThemeProviderProps) {
  const [themeColor, setThemeColor] = useState<BaseThemeColors>({
    primary: DEFAULT_PRIMARY_COLOR,
    secondary: DEFAULT_SECONDARY_COLOR,
  });

  return (
    <ThemeContext.Provider
      value={{
        themeColor,
        setThemeColor,
      }}
    >
      <ChakraProvider theme={chakraTheme(themeColor)}>
        <StyledComponentsThemeProvider theme={materialTheme(themeColor)}>
          {props.children}
        </StyledComponentsThemeProvider>
      </ChakraProvider>
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
